<template>
  <div id="app">
    <div class="input_container">
      <span id="pwRequirements">Password Requirements</span>
      <span id="autoChecked">(Enter password below requirement list)</span>
      <ul class="ckBoxes">
        <ro-check :valid="ck8chars" :text="minChars" />
        <ro-check :valid="ck32chars" :text="maxChars" />
        <ro-check :valid="ckNumbers" text="Contains Numbers" />
        <ro-check :valid="ckUpper" text="Contains Uppercase" />
        <ro-check :valid="ckLower" text="Contains Lowercase" />
        <ro-check :valid="ckSpecial" text="Contains Special Characters" />
        <ro-check :valid="ckNoSpaces" text="Contains NO Spaces" />
        <ro-check v-if="hidePass === true" :valid="pwMatch" text="Passwords Match" />
        <ro-check :valid="valid_password" text="All Requirements Satisfied" />
      </ul>
      <div :style="{height: boxHeight + 'px'}" class="pwStrengthOver" @click="pwSetFocus"></div>
      <div class="checkmark_container" v-bind:class="{ show_checkmark: valid_password }">
        <svg width="50%" height="50%" viewBox="0 0 140 100">
          <path class="checkmark"
               v-bind:class="{ checked: valid_password }"
               d="M10,50 l25,40 l95,-70" />
        </svg>
      </div>
      <div>
        <b-form-input :name="pw1Rand"
                     @input="checkPassword"
                     ref="pw1"
                     autocomplete="nope"
                     autocorrect="off"
                     autocapitalize="off"
                     spellcheck="false"
                     class="inputField"
                     aria-label="New Password"
                     :style="passStyle"
                     type="text"
                     v-model="password"
                     required
                     placeholder="New Password">
        </b-form-input>
      </div>
      <div v-if="hidePass === true">
        <div style="height: 5px;"></div>
        <b-form-input :name="pw2Rand"
                    @input="checkPassword"
                    ref="pw2"
                    autocomplete="nope"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                    class="inputField"
                    aria-label="Password Again"
                    :style="passStyle"
                    type="text"
                    v-model="password2"
                    required
                    placeholder="Password Again">
        </b-form-input>
        <div class="checkmatch_container" v-bind:class="{ show_checkmark: pwMatch }">
          <svg width="50%" height="50%" viewBox="0 0 140 100">
            <path class="checkmark"
                v-bind:class="{ checked: pwMatch }"
                d="M10,50 l25,40 l95,-70" />
          </svg>
        </div>
      </div>
      <div style="height: 20px;"></div>
      <b-form-checkbox id="hiPass"
                     v-model="hidePass"
      >Hide Password
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import utl from '../myUtils';
import roCheck from './roCheck';

export default {
  components: {
    roCheck,
  },
  name: 'zPass',
  data() {
    return {
      boxHeight: 200,
      passStyle: '',
      hidePass: false,
      pwMatch: false,
      password: '',
      password2: '',
      password_length: 0,
      valid_password: false,
      ck8chars: false,
      ck32chars: false,
      ckNumbers: false,
      ckUpper: false,
      ckLower: false,
      ckSpecial: false,
      ckNoSpaces: false,
      ck8Color: 'red',
      ck32Color: 'red',
      ckNumColor: 'red',
      ckUppColor: 'red',
      ckLowColor: 'red',
      ckSpecColor: 'red',
      ckNoSpColor: 'red',
      ckPwMatchColor: 'red',
      ckAllMatchColor: 'red',
      maxPW: 0,
    };
  },
  watch: {
    hidePass() {
      this.onHidePwChange();
    },
    extendedPW() {
      this.checkPassword();
    },
    focusPW() {
      if (this.focusPW === true) {
        utl.diag('z-pass:watch:focusPW called - true');
        this.$store.commit('setFocusChangePW', false);
        this.$refs.pw1.focus();
      } else {
        utl.diag('z-pass:watch:focusPW called - false');
      }
    },
  },
  computed: {
    pw1Rand() {
      return this.$store.getters.getPw1Rand;
    },
    pw2Rand() {
      return this.$store.getters.getPw2Rand;
    },
    extendedPW() {
      return this.$store.getters.getExtendedPwStatus;
    },
    focusPW() {
      return this.$store.getters.getFocusChangePW;
    },
    minChars() {
      return `8 Characters (or more) [${this.password_length}]`;
    },
    maxChars() {
      return `${this.maxPW} Characters (or less) [${this.password_length}]`;
    },
  },
  methods: {
    checkPassword() {
      this.checkExt();
      this.password_length = this.password.length;
      const format = /[!@#$%^&*~`//()_+\-=[\]{};':"\\|,.<>?]/;
      const spaces = /[ ]/;

      this.pwMatch = ((this.password2.length > 0) && (this.password2 === this.password));
      if (this.hidePass === false) this.pwMatch = true;

      if (this.password_length > 7) {
        this.ck8chars = true;
        this.ck8Color = 'green';
      } else {
        this.ck8chars = false;
        this.ck8Color = 'red';
      }

      if ((this.password_length <= this.maxPW) && (this.password_length > 0)) {
        this.ck32chars = true;
        this.ck32Color = 'green';
      } else {
        this.ck32chars = false;
        this.ck32Color = 'red';
      }

      this.ckNumbers = /[0-9]/.test(this.password);
      this.ckUpper = /[A-Z]/.test(this.password);
      this.ckLower = /[a-z]/.test(this.password);
      this.ckSpecial = format.test(this.password);
      this.ckNoSpaces = !spaces.test(this.password.trim());
      if (this.password_length === 0) this.ckNoSpaces = false;

      if (this.pwMatch === true) {
        this.ckPwMatchColor = 'green';
      } else {
        this.ckPwMatchColor = 'red';
      }
      if (this.ckNumbers === true) {
        this.ckNumColor = 'green';
      } else {
        this.ckNumColor = 'red';
      }
      if (this.ckUpper === true) {
        this.ckUppColor = 'green';
      } else {
        this.ckUppColor = 'red';
      }
      if (this.ckLower === true) {
        this.ckLowColor = 'green';
      } else {
        this.ckLowColor = 'red';
      }
      if (this.ckSpecial === true) {
        this.ckSpecColor = 'green';
      } else {
        this.ckSpecColor = 'red';
      }
      if (this.ckNoSpaces === true) {
        this.ckNoSpColor = 'green';
      } else {
        this.ckNoSpColor = 'red';
      }

      if (this.ck8chars === true &&
        this.ck32chars === true &&
        this.ckNoSpaces === true &&
        this.ckSpecial === true &&
        this.ckUpper === true &&
        this.ckLower === true &&
        this.pwMatch === true &&
        this.ckNumbers === true) {
        this.valid_password = true;
        this.ckAllMatchColor = 'green';
        this.hideAlert();
      } else {
        this.valid_password = false;
        this.ckAllMatchColor = 'red';
      }
      this.$store.commit('setNewPassword', this.password.trim());
      this.$store.commit('setPwValid', this.valid_password);
    },
    checkExt() {
      if (this.extendedPW === true) {
        this.maxPW = 32;
      } else {
        this.maxPW = 16;
      }
    },
    onHidePwChange() {
      this.updatePwVisible();
      this.$refs.pw1.$el.focus();
    },
    updatePwVisible() {
      if (this.hidePass === true) {
        // utl.diag('updatePwVisible - true = hidePW');
        this.hidePW();
      } else {
        // utl.diag('updatePwVisible - false = showPW');
        this.showPW();
      }
      this.checkPassword(); // Set check marks and colors when HidePass changes
    },
    hidePW() {
      const x = document.getElementById('pw1');
      const y = document.getElementById('pw2');
      if (x) x.type = 'password';
      if (y) y.type = 'password';
      this.passStyle = 'text-security:disc; -webkit-text-security:disc;';
      this.boxHeight = 225;
    },
    showPW() {
      const x = document.getElementById('pw1');
      const y = document.getElementById('pw2');
      if (x) { x.type = 'text'; }
      if (y) { y.type = 'text'; }
      this.passStyle = '';
      this.boxHeight = 200;
    },
    pwSetFocus() {
      // const x = document.getElementById('pw1');
      // utl.diag('pwSetFocus');
      this.$refs.pw1.$el.focus(); // Set Focus on element with ref="siUser"
    },
    ssnSetFocus() {
      // utl.diag('ssnSetFocus');
      this.$store.commit('setDoSsnFocus', true);
    },
    hideAlert() { // Clear alert that was set by sendPin.vue
      this.$store.commit('setAlertShow', false);
    },
    handleKeyStroke(event) {
      let keyCode = event.keyCode;
      // const e1 = document.activeElement;
      // utl.diag(`z-pass-keyPressed: ${event.keyCode}`);
      if (keyCode === 13) { // Enter Pressed
        // utl.diag('Enter Pressed');
        // utl.diag(`e1.name="${e1.name}"`);
        keyCode = 0;
        event.preventDefault();
        event.stopPropagation(true);
      }
    },
  },
  mounted() {
    // const myDate = +new Date();
    // this.pw1Rand = `pw1${myDate}`;
    // this.pw2Rand = `pw2${myDate}`;
    /*
    const ck8 = document.getElementById('ck8');
    const val = document.getElementById('val');
    ck8.addEventListener('focus', (event) => {
      this.pwSetFocus(event);
    });
    val.addEventListener('focus', (event) => {
      this.ssnSetFocus(event);
    }); */
    this.checkPassword(); // Set initial check marks and colors
  },
  created() {
    window.addEventListener('keypress', this.handleKeyStroke);
  },
  destroyed() {
    window.removeEventListener('keypress', this.handleKeyStroke);
  },
};
</script>

<style scoped>
 /* Basic Config --------- */

 html { box-sizing: border-box; }

 *, *:before, *:after { box-sizing: inherit; }

 html, body {
   height: 100%;
   width: 100%;
   margin: 0;
   padding: 0;
 }

 body {
   font-family: 'Open Sans', sans-serif;
   display: flex;
   justify-content: center;
   align-items: center;
   background: #ff6b6b;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
 }

 .ckBoxes {
   font-weight: bold;
   font-size: 14px;
   color: blue;
 }

 h2 {
   text-align: center;
   color: red;
   font-weight: bold;
 }

 ul {
   padding-left: 5px;
   display: flex;
   flex-direction: column;
   align-items: flex-start;
 }

 li {
   margin-bottom: 8px;
   color: #525f7f;
   position: relative;
 }
 li:before {
   content: "";
   width: 0%; height: 2px;
   background: #2ecc71;
   position: absolute;
   left: 0; top: 50%;
   display: block;
   transition: all .6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
 }

 #app {
   width: 300px;
   margin: auto;
 }
 #pwRequirements {
   position: absolute;
   color: blue;
   top: 0px;
   left: 50px;
   width: 200px;
   margin: auto;
   font-size: 16px;
   font-weight: bold;
 }


 /* Password Input --------- */

 .input_container {
   position: relative;
   padding: 30px;
   /* box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23); */
   border-radius: 6px;
   background: #FFF;
 }

 input[type="password"] {
   line-height: 1.5;
   display: block;
   color: rgba(136, 152, 170, 1);
   font-weight: 300;
   width: 100%;
   height: calc(2.75rem + 2px);
   padding: .625rem .75rem;
   border-radius: .25rem;
   background-color: #fff;
   transition: border-color .4s ease;
   border: 1px solid #cad1d7;
   outline: 0;
 }

 input[type="password"]:focus {
   border-color: rgba(50, 151, 211, .45);
 }


 /* Checkmark & Strikethrough --------- */

 .is_valid { color: rgba(136, 152, 170, 0.8); }
 .is_valid:before { width: 100%; }

 #zipContainer {
   position: relative;
   width: 200px;
   margin: auto;
 }
 #zipCM {
   position: absolute;
   top: 4px; right: -50px;
 }

 .checkmark_container {
   border-radius: 50%;
   position: absolute;
   top: -15px; right: -15px;
   background: #2ecc71;
   width: 50px; height: 50px;
   visibility: hidden;
   opacity: 0;
   display: flex;
   justify-content: center;
   align-items: center;
   transition: opacity .4s ease;
 }
 .checkmatch_container {
   border-radius: 500%;
   position: absolute;
   top: 333px; right: 10px;
   background: #2ecc71;
   width: 40px; height: 40px;
   visibility: hidden;
   opacity: 0;
   display: flex;
   justify-content: center;
   align-items: center;
   transition: opacity .4s ease;
 }
 .pwStrengthOver {
   position: absolute;
   top: 25px; left: 0px;
   width: 300px;
   height: 175px;
   z-index: 99;
   /* border: solid 1px blue; */
 }

 .show_checkmark {
   visibility: visible;
   opacity: 1;
 }

 .checkmark {
   width: 100%;
   height: 100%;
   fill: none;
   stroke: white;
   stroke-width: 15;
   stroke-linecap: round;
   stroke-dasharray: 180;
   stroke-dashoffset: 180;
 }
 #autoChecked {
   position: relative;
   top: -10px;
   padding: 0px;
   font-size: 12px;
   font-weight: normal;
 }
 .checked { animation: draw 0.5s ease forwards; }

 @keyframes draw {
   to { stroke-dashoffset: 0; }
 }
</style>



// WEBPACK FOOTER //
// src/components/z-pass.vue